import React, { useEffect, memo } from 'react';
import { truncateString } from '@helpers/stringHelpers';
import { NewsItem } from '@pages/NewsList/NewsList.types';

interface NewsListItemHorizontalProps {
  model: NewsItem;
}

export const NewsListItemHorizontal = memo(({ model }: NewsListItemHorizontalProps) => {
  return (
    <a href={model.ContentLink} className='c-news-block c-news-block-vertical'>
      <div className='c-news-block-container'>
        <div className='c-news-block-thumbnail'>
          <img
            loading='lazy'
            src={model.Image}
            alt={model.ImageAlt}
            className='c-news-block-list-image'
            height='360'
            width='640'
          />
        </div>
        <div className='c-news-block-content'>
          <span className='c-news-block-date-text'>{model.Date}</span>
          <h4 className='c-news-block-title-text'>{model.Title}</h4>
          {model.Introduction && (
            <p className='c-news-block-content-text'>{truncateString(model.Introduction, 130)}</p>
          )}
        </div>
      </div>
    </a>
  );
});
